import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { loadGames } from '../services/games';
const GamesContext = createContext(null);
export function GamesProvider({ children }) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ games: [], loading: true, error: '', failedCount: 0 });
  const retry = useCallback(() => setAttempt(value => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    setState({ games: [], loading: true, error: '', failedCount: 0 });
    loadGames(controller.signal).then(result => {
      if (!controller.signal.aborted) setState({ ...result, loading: false, error: '' });
    }).catch(error => {
      if (!controller.signal.aborted) {
        console.error(error);
        setState({ games: [], loading: false, error: 'Não foi possível carregar os jogos.', failedCount: 0 });
      }
    });
    return () => controller.abort();
  }, [attempt]);
  return <GamesContext.Provider value={{ ...state, retry }}>{children}</GamesContext.Provider>;
}
export const useGames = () => useContext(GamesContext);
